import { render, staticRenderFns } from "./ford-throughput.page.vue?vue&type=template&id=4f3eecc8"
import script from "./ford-throughput.page.vue?vue&type=script&lang=ts"
export * from "./ford-throughput.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports